import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function CustomizedTables({ rawRows }) {
  const rows = rawRows.map((item) => item.value.map((item) => item.value));
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {rows.map(
              (row, idx) =>
                idx === 0 &&
                row.map((item, idx) => (
                  <StyledTableCell align="left" id={idx} key={idx}>
                    {item}
                  </StyledTableCell>
                ))
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(
            (row, idx) =>
              idx > 0 && (
                <StyledTableRow key={idx} id={idx}>
                  {row.map((item, idx) => (
                    <StyledTableCell align="left" id={idx} key={idx}>
                      {item}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
